const getCollapseBottom = (section: HTMLElement) =>
  window.innerWidth < 640
    ? section.dataset.collapseBottom
    : (section.dataset.collapseBottomSm ?? section.dataset.collapseBottom);

const getCollapseTop = (section: HTMLElement) =>
  window.innerWidth < 640
    ? section.dataset.collapseTop
    : (section.dataset.collapseTopSm ?? section.dataset.collapseTop);

/**
 * Disables the section's top-padding (sets it to 0) if the current section has data-collapse-top
 * set to "true", and the previous section has data-collapse-bottom also set to "true".
 * Also has semi-responsive support (supports changing these values in sm/640px breakpoint).
 */
const updatePaddingCollapsing = () => {
  const elementsToCollapse: HTMLElement[] = [];
  const elementsToClear: HTMLElement[] = [];

  document.querySelectorAll<HTMLElement>("[data-section]").forEach(section => {
    let collapseTop = false;

    const bgColor = getComputedStyle(section).backgroundColor;

    const shouldCollapseAgainst = (previousSection: HTMLElement | null | undefined) =>
      previousSection?.dataset.section !== undefined &&
      getCollapseBottom(previousSection) === "true" &&
      getComputedStyle(previousSection).backgroundColor === bgColor;

    if (getCollapseTop(section) === "true") {
      let previousSection = section.previousElementSibling as
        HTMLElement | null | undefined;

      if (shouldCollapseAgainst(previousSection)) {
        collapseTop = true;
      } else {
        const parent = section.parentElement as HTMLElement | null;

        if (parent?.dataset.block !== undefined) {
          const previousParent = parent.previousElementSibling as HTMLElement | null;

          previousSection = previousParent?.querySelector<HTMLElement>("[data-section]");

          if (shouldCollapseAgainst(previousSection)) {
            collapseTop = true;
          }
        }
      }
    }

    if (collapseTop) {
      elementsToCollapse.push(section);
    } else {
      elementsToClear.push(section);
    }
  });

  // Batch and apply all "writes" at once, to not mix layout reads and writes, reducing layout thrashing.
  elementsToCollapse.forEach(element => (element.style.paddingTop = "0"));
  elementsToClear.forEach(element => (element.style.paddingTop = ""));
};

// Resize listener for semi-responsiveness
window.addEventListener("resize", () => {
  updatePaddingCollapsing();
});

updatePaddingCollapsing();
